import { render } from "./PwdInput.vue?vue&type=template&id=0556e202&scoped=true"
import script from "./PwdInput.vue?vue&type=script&lang=js"
export * from "./PwdInput.vue?vue&type=script&lang=js"

import "./PwdInput.vue?vue&type=style&index=0&id=0556e202&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0556e202"]])

export default __exports__